import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { push } from 'connected-react-router'
import { BButton, BLink, BText } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../../../hoc'
import messages from '../../../../i18n'
import Routes from '../../../../constants/routes'
import { ReduxState } from '../../../../types'
import { WizardStep } from '../../../../constants/wizard'
import { SHOW_NEEDED_DOCS } from '../../../../constants/modals'
import { modalDialogActions } from '../../../../redux/reducers'

import styles from './styles.scss'

interface Props extends IntlInterface {
  actualStep: WizardStep
  push: Function
  showModalDialog: typeof modalDialogActions.showModalDialog
}

export const SaveAndLeaveButton = ({ actualStep, push, showModalDialog, translate }: Props) => {
  const leave = () => push(Routes.EXIT)

  const toBranch = () => showModalDialog(SHOW_NEEDED_DOCS)

  if (!actualStep || actualStep.step === undefined || actualStep === null) return null

  return (
    <>
      <BButton
        messages={{
          message: translate(messages.sidePanel.leaveButton),
        }}
        type="button"
        testid="leaveButton"
        size="lg"
        onClick={leave}
        theme={styles.leaveButton}
      />
      {actualStep.step > 2 && (
        <>
          <BText type="primary" theme={styles.branchQuestion}>
            {translate(messages.sidePanel.branchQuestion)}
          </BText>
          <BLink onClick={toBranch} data-testid="branchLink">
            {translate(messages.sidePanel.arrangeVisit)}
          </BLink>
        </>
      )}
    </>
  )
}

export default compose(
  connect(
    (state: ReduxState) => ({
      actualStep: state.wizard.actualStep,
    }),
    {
      showModalDialog: modalDialogActions.showModalDialog,
      push,
    }
  ),
  intl
)(SaveAndLeaveButton)
